import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireRole } from '@/lib/routeGuards';

/** Layout-гард кабинета учителя: /teacher/* доступен только teacher. */
export const Route = createFileRoute('/_authed/teacher')({
  beforeLoad: () => requireRole('teacher'),
  component: Outlet,
});
